var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('h1',[_vm._v("404 Not Found")]),_c('a',{attrs:{"href":"javascript:history.back()"}},[_vm._v("GO BACK")]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("HOMEPAGE")])])])])
}]

export { render, staticRenderFns }